/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SupplierCataloguesBox__SupplierCatalogueFragment = { __typename: 'PimSupplierCatalogue', id: string, isDefault: boolean, supplierId: string, title: string, supplierCatalogueSubscription?: { __typename: 'PimSupplierCatalogueSubscription', id: string, createdAt: any } | null };

export type SupplierCataloguesBoxQueryVariables = Types.Exact<{
  supplierId: Types.Scalars['ID']['input'];
}>;


export type SupplierCataloguesBoxQuery = { pimGetSupplierCatalogues: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'PimGetSupplierCataloguesResult', supplierCatalogues: Array<{ __typename: 'PimSupplierCatalogue', id: string, isDefault: boolean, supplierId: string, title: string, supplierCatalogueSubscription?: { __typename: 'PimSupplierCatalogueSubscription', id: string, createdAt: any } | null }> } };

export type SupplierCataloguesBox__SubscribeToMutationVariables = Types.Exact<{
  input: Types.PimSubscribeToSupplierCatalogueInput;
}>;


export type SupplierCataloguesBox__SubscribeToMutation = { pimSubscribeToSupplierCatalogue: { __typename: 'PimSubscribeToSupplierCatalogueResult', supplierCatalogue: { __typename: 'PimSupplierCatalogue', id: string, isDefault: boolean, supplierId: string, title: string, supplierCatalogueSubscription?: { __typename: 'PimSupplierCatalogueSubscription', id: string, createdAt: any } | null } } };

export type SupplierCataloguesBox__UnsubscribeFromMutationVariables = Types.Exact<{
  input: Types.PimUnsubscribeFromSupplierCatalogueInput;
}>;


export type SupplierCataloguesBox__UnsubscribeFromMutation = { pimUnsubscribeFromSupplierCatalogue: { __typename: 'PimUnsubscribeFromSupplierCatalogueResult', supplierCatalogue: { __typename: 'PimSupplierCatalogue', id: string, isDefault: boolean, supplierId: string, title: string, supplierCatalogueSubscription?: { __typename: 'PimSupplierCatalogueSubscription', id: string, createdAt: any } | null } } };

export const SupplierCataloguesBox__SupplierCatalogueFragmentDoc = gql`
    fragment SupplierCataloguesBox__SupplierCatalogue on PimSupplierCatalogue {
  id
  isDefault
  supplierId
  title
  supplierCatalogueSubscription {
    id
    createdAt
  }
}
    `;
export const SupplierCataloguesBoxDocument = gql`
    query SupplierCataloguesBox($supplierId: ID!) {
  pimGetSupplierCatalogues(supplierId: $supplierId) {
    ... on PimGetSupplierCataloguesResult {
      supplierCatalogues {
        id
        ...SupplierCataloguesBox__SupplierCatalogue
      }
    }
  }
}
    ${SupplierCataloguesBox__SupplierCatalogueFragmentDoc}`;

/**
 * __useSupplierCataloguesBoxQuery__
 *
 * To run a query within a React component, call `useSupplierCataloguesBoxQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierCataloguesBoxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierCataloguesBoxQuery({
 *   variables: {
 *      supplierId: // value for 'supplierId'
 *   },
 * });
 */
export function useSupplierCataloguesBoxQuery(baseOptions: Apollo.QueryHookOptions<SupplierCataloguesBoxQuery, SupplierCataloguesBoxQueryVariables> & ({ variables: SupplierCataloguesBoxQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupplierCataloguesBoxQuery, SupplierCataloguesBoxQueryVariables>(SupplierCataloguesBoxDocument, options);
      }
export function useSupplierCataloguesBoxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupplierCataloguesBoxQuery, SupplierCataloguesBoxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupplierCataloguesBoxQuery, SupplierCataloguesBoxQueryVariables>(SupplierCataloguesBoxDocument, options);
        }
export function useSupplierCataloguesBoxSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupplierCataloguesBoxQuery, SupplierCataloguesBoxQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SupplierCataloguesBoxQuery, SupplierCataloguesBoxQueryVariables>(SupplierCataloguesBoxDocument, options);
        }
export type SupplierCataloguesBoxQueryHookResult = ReturnType<typeof useSupplierCataloguesBoxQuery>;
export type SupplierCataloguesBoxLazyQueryHookResult = ReturnType<typeof useSupplierCataloguesBoxLazyQuery>;
export type SupplierCataloguesBoxSuspenseQueryHookResult = ReturnType<typeof useSupplierCataloguesBoxSuspenseQuery>;
export type SupplierCataloguesBoxQueryResult = Apollo.QueryResult<SupplierCataloguesBoxQuery, SupplierCataloguesBoxQueryVariables>;
export const SupplierCataloguesBox__SubscribeToDocument = gql`
    mutation SupplierCataloguesBox__SubscribeTo($input: PimSubscribeToSupplierCatalogueInput!) {
  pimSubscribeToSupplierCatalogue(input: $input) {
    supplierCatalogue {
      id
      ...SupplierCataloguesBox__SupplierCatalogue
    }
  }
}
    ${SupplierCataloguesBox__SupplierCatalogueFragmentDoc}`;
export type SupplierCataloguesBox__SubscribeToMutationFn = Apollo.MutationFunction<SupplierCataloguesBox__SubscribeToMutation, SupplierCataloguesBox__SubscribeToMutationVariables>;

/**
 * __useSupplierCataloguesBox__SubscribeToMutation__
 *
 * To run a mutation, you first call `useSupplierCataloguesBox__SubscribeToMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSupplierCataloguesBox__SubscribeToMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [supplierCataloguesBoxSubscribeToMutation, { data, loading, error }] = useSupplierCataloguesBox__SubscribeToMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSupplierCataloguesBox__SubscribeToMutation(baseOptions?: Apollo.MutationHookOptions<SupplierCataloguesBox__SubscribeToMutation, SupplierCataloguesBox__SubscribeToMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SupplierCataloguesBox__SubscribeToMutation, SupplierCataloguesBox__SubscribeToMutationVariables>(SupplierCataloguesBox__SubscribeToDocument, options);
      }
export type SupplierCataloguesBox__SubscribeToMutationHookResult = ReturnType<typeof useSupplierCataloguesBox__SubscribeToMutation>;
export type SupplierCataloguesBox__SubscribeToMutationResult = Apollo.MutationResult<SupplierCataloguesBox__SubscribeToMutation>;
export type SupplierCataloguesBox__SubscribeToMutationOptions = Apollo.BaseMutationOptions<SupplierCataloguesBox__SubscribeToMutation, SupplierCataloguesBox__SubscribeToMutationVariables>;
export const SupplierCataloguesBox__UnsubscribeFromDocument = gql`
    mutation SupplierCataloguesBox__UnsubscribeFrom($input: PimUnsubscribeFromSupplierCatalogueInput!) {
  pimUnsubscribeFromSupplierCatalogue(input: $input) {
    supplierCatalogue {
      id
      ...SupplierCataloguesBox__SupplierCatalogue
    }
  }
}
    ${SupplierCataloguesBox__SupplierCatalogueFragmentDoc}`;
export type SupplierCataloguesBox__UnsubscribeFromMutationFn = Apollo.MutationFunction<SupplierCataloguesBox__UnsubscribeFromMutation, SupplierCataloguesBox__UnsubscribeFromMutationVariables>;

/**
 * __useSupplierCataloguesBox__UnsubscribeFromMutation__
 *
 * To run a mutation, you first call `useSupplierCataloguesBox__UnsubscribeFromMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSupplierCataloguesBox__UnsubscribeFromMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [supplierCataloguesBoxUnsubscribeFromMutation, { data, loading, error }] = useSupplierCataloguesBox__UnsubscribeFromMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSupplierCataloguesBox__UnsubscribeFromMutation(baseOptions?: Apollo.MutationHookOptions<SupplierCataloguesBox__UnsubscribeFromMutation, SupplierCataloguesBox__UnsubscribeFromMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SupplierCataloguesBox__UnsubscribeFromMutation, SupplierCataloguesBox__UnsubscribeFromMutationVariables>(SupplierCataloguesBox__UnsubscribeFromDocument, options);
      }
export type SupplierCataloguesBox__UnsubscribeFromMutationHookResult = ReturnType<typeof useSupplierCataloguesBox__UnsubscribeFromMutation>;
export type SupplierCataloguesBox__UnsubscribeFromMutationResult = Apollo.MutationResult<SupplierCataloguesBox__UnsubscribeFromMutation>;
export type SupplierCataloguesBox__UnsubscribeFromMutationOptions = Apollo.BaseMutationOptions<SupplierCataloguesBox__UnsubscribeFromMutation, SupplierCataloguesBox__UnsubscribeFromMutationVariables>;